import React from 'react'
import AboutSidelink from "../../component/AboutSidelink";
// import { Link } from "react-router-dom";

export default function FounderContent() {
  return (
    <>
    <div className="pastoral-area princ-chair">
        <div className="container">
            <div className="row">  
                <div className="col-lg-9 col-md-8">
                    <div className="pastoral-content">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-sm-6 col-md-8">
                                <img src="/image/late-shri-c-p-singh.webp" alt="chairman" className="img-responsive radius-8"/>
                            </div>

                            <div className="col-lg-6 col-sm-6 col-md-12">
                                <div className="imagename-box">
                                    <p>Late Shri C. P. Singh was a visionary educator who believed that education should shape not only capable minds but also responsible, compassionate, and confident individuals. Born in Ugu, Unnao, he dedicated his life to making quality, value-based education accessible to all.</p>
                                    <p>In 1983, he began with just 26 students in a modest rented house, laying the foundation for a remarkable educational journey. His vision became Lucknow Public School in 1988, built on the principles of discipline, integrity, excellence, and service. Though he passed away in 2006, his ideals continue to guide LPS, inspiring generations to “Come to Learn, Go to Serve.”</p>
                                    {/* <img src="/image/chairman-sign.webp" alt="sign"/> */}
                                    <h2 className="princple-name"><span>Late Shri C. P. Singh,</span> Founder</h2>
                                    {/* <Link to={""} className='default-btn whitetheme-bluebtn'>
                                        <div><span>Our Strategic vision</span><span>Our Strategic vision</span></div>
                                    </Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-3 col-md-4">
                    <AboutSidelink/>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
